/**
 * Vite entry for `js/scripts`. Add new ES modules here; the legacy script runs as a side-effect import.
 * @see ./legacy/site-bundle.js
 */
import "./legacy/site-bundle.js";
import "./accordion-audio.js";
import "./modules/hero-video.js";
